// extracted by mini-css-extract-plugin
export default {"modal":"ModalCheckPackage_modal__RzUYR","content":"ModalCheckPackage_content__Ob7j6","btnMore":"ModalCheckPackage_btnMore__SVhRW","btnClose":"ModalCheckPackage_btnClose__HOY9a"};